import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Lottie from "lottie-react";

// 👉 Put your lottie json in src/assets and import it
// Example: import confirmAnim from "../assets/lotties/confirm.json";
import confirmAnim from "../../lotties/Success.json";

const SucessDialog = ({
  open,
  onClose,
  onSubmit,
  title = "Listing Successfully Created",
  message ="Listing has been successfully created. Thank You!",
  confirmText = "ok",
  
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0px 20px 60px rgba(0,0,0,0.15)",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 10,
          top: 10,
          bgcolor: "rgba(0,0,0,0.05)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.1)" },
        }}
      >
        <CloseRoundedIcon />
      </IconButton>

      {/* Header */}
      <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
        <Box sx={{ width: 140,height : 140, mx: "auto", mb: 1 }}>
          <Lottie animationData={confirmAnim} loop={true} />
        </Box>

        <Typography fontWeight={700} fontSize={18}>
          {title}
        </Typography>

        <Typography
          fontSize={13}
          sx={{ mt: 0.8, color: "text.secondary", px: 2 }}
        >
          {message}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 0 }} />

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
        {/* <Button
          fullWidth
          variant="outlined"
          onClick={onClose}
          sx={{
            borderRadius: 3,
            py: 1.2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {cancelText}
        </Button> */}

        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          onClick={onSubmit}
          sx={{
            borderRadius: 3,
            py: 1.2,
            textTransform: "none",
            fontWeight: 700,
            background:
              "linear-gradient(90deg, rgba(79,70,229,1) 0%, rgba(99,102,241,1) 100%)",
            "&:hover": {
              background:
                "linear-gradient(90deg, rgba(67,56,202,1) 0%, rgba(79,70,229,1) 100%)",
            },
          }}
        >
          {loading ? "Please wait..." : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SucessDialog;


